import { getInteractionCallbackErrorMessage as errorMessage } from "./constants";

const getInteractionCallbackError = interactionCallback => {
  if (!["function", "undefined"].includes(typeof interactionCallback)) {
    return errorMessage;
  }
};

export default getInteractionCallbackError;
